"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loader = void 0;
/** @jsxRuntime classic */
/** @jsx jsx */
var react_loader_spinner_1 = __importDefault(require("react-loader-spinner"));
var theme_ui_1 = require("theme-ui");
var theme_1 = require("../../../theme");
function Loader(_a) {
    var _b = _a.visible, visible = _b === void 0 ? true : _b;
    return (theme_ui_1.jsx(react_loader_spinner_1.default, { visible: visible, type: "TailSpin", color: theme_1.theme.colors.primary, height: 50, width: 50 }));
}
exports.Loader = Loader;
